<template>
  <m-base :showTopBorder="pattern.showTopBorder" :showBottomBorder="pattern.showBottomBorder">
    <div slot="box" class="w-100" :style="{backgroundColor:pattern.backgroundColor}">
      <div>
        <!-- <div
          class="d-flex flex-column van-row--justify-center van-row--align-center"
          v-for="(item, index) in data"
          :key="index"
          @click="changeSwiperIndex(index)"
        >
          <div
            class="title"
            :class="{currentTitle:swiperIndex==index}"
            :style="{color:swiperIndex!=index&&pattern.titleColor?pattern.titleColor:'var(--theme-font-color)'}"
          >{{screenWidth}}</div>
          <div v-show="swiperIndex==index" class="titleBorder"></div>
        </div>-->
        <van-swipe
          :width="data.length>=3?screenWidth/3:screenWidth/data.length"
          autoplay="0"
          :loop="false"
          ref="tabs"
          class="tabs"
          :show-indicators="false"
          @change="changeSwiperIndex"
        >
          <van-swipe-item v-for="(item,index) in data" :key="index">
            <div
              @click="changeSwiperIndex(index)"
              :style="{height:screenWidth/3+'px',width:screenWidth/3+'px'}"
              class="flex-center"
            >
              <van-image
                style="transition: all 0.3s"
                :class="{currentTabImage:tabIndex==index,tabImage:tabIndex!=index}"
                :src="item.img"
              />
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <van-swipe
        width="100%"
        class="car"
        ref="swipe"
        :autoplay="0"
        :show-indicators="false"
        :loop="false"
        @change="swiperChange"
        :touchable="false"
      >
        <van-swipe-item
          v-for="(item, index) in data"
          :key="index"
          class="car-item"
          :style="{paddingLeft:pattern.showLeftBorder?'10px':'0px',paddingRight:pattern.showRightBorder?'10px':'0px'}"
        >
          <my-swiper-card2
            :data="item"
            :showBorderRadius="pattern.showBorderRadius"
            :backgroundColor="pattern.cardBackgroundColor"
            :boxType="pattern.boxType"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
  </m-base>
</template>
<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => {
        return [
          {
            type: 'image',
            img: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268',
            list: [{
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }, {
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }, {
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }],
          },
          {
            type: 'image',
            img: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268',
            list: [{
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }],
          },
          {
            type: 'image',
            img: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268',
            list: [{
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }],
          },
          {
            type: 'image',
            img: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268',
            list: [{
              src: 'http://192.168.1.15:8765/api/backend/test/thumb?id=268'
            }],
          }
        ]
      }
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showRightBorder: false,
          showBorderRadius: false,
          titleColor: 'rgba(0,0,0,1)',
          backgroundColor: 'rgba(255,255,255,0)',
          cardBackgroundColor: 'rgba(255,255,255,0)',
          boxType: 'block',
        }
      }
    },
  },
  data () {
    return {
      screenWidth: document.body.clientWidth,
      tabIndex: 0,
      swiperIndex: 0,
      juli: 0,
      moving: false,
      coverTransition: '0s',
      height: 360,
    }
  },
  created () {

  },
  mounted () {
  },
  methods: {

    swiperChange (index) {
      this.swiperIndex = index
      this.$refs.tabs.swipeTo(index)
    },
    changeSwiperIndex (index) {
      this.tabIndex = index
      this.$refs.swipe.swipeTo(index)
    },
  }
}
</script>
<style lang='scss' scoped>
.titleDiv {
  // padding: 5px;
}
.title {
  margin: 5px;
  font-size: 14px;
  line-height: 16px;
}
.titleBorder {
  height: 4px;
  width: 8px;
  border-radius: 2px;
  background-color: var(--theme-font-color);
}
.currentTitle {
  color: var(--theme-font-color);
  font-size: 16px;
}
.content {
  overflow: hidden;
  position: relative;
  // background-color: black;
}
.tabImage {
  width: 70%;
  height: 70%;
}
.currentTabImage {
  width: 90%;
  height: 90%;
}
.list {
  margin: 0 auto;
  width: 80%;
  position: relative;
}
.item {
  position: absolute;
  width: 100%;
  overflow: hidden;
}
.item-img {
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.6s;
  margin: 5px;
  box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
}
.swiper-dots2 {
  display: flex;
  position: absolute;
  right: calc(10% / 2);
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .block {
    width: 7px;
    height: 7px;
    border-radius: 4px;
    background-color: white;
    margin: 3px 0px;
    transition: all 0.5s;
    box-shadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);
  }
  .current {
    height: 18px;
    background-color: var(--theme-font-color);
  }
}
</style>
